import type { AffiliateStockListing, CapiProductPage } from 'types/capi/pdp';
import { fromProductDetailPage } from 'types/TrackableProduct';

import RetailerInteractionEvent, {
  type RetailerOption
} from '~/events/RetailerInteractionEvent';
import usePageData from '~/hooks/usePageData';
import useRootData from '~/hooks/useRootData';
import {
  getPriceForSize,
  getSortedStockListingsForSize,
  getStockStatusForSize
} from '~/utils/listings';

type FireOptions = {
  listing: AffiliateStockListing;
  selectedSize?: string;
};

function toRetailerOption(
  listing: AffiliateStockListing,
  index: number,
  selectedSize?: string
): RetailerOption {
  const price = getPriceForSize(listing, selectedSize) ?? listing.price;

  return {
    available_sizes: listing.sizes,
    position: index + 1,
    price_currency: price.currency,
    price_regular: price.regular ?? -1,
    price_sale: price.sale ?? undefined,
    retailer_id: listing.affiliate.canonical_id,
    stock_status: getStockStatusForSize(listing, selectedSize)
  };
}

export default function useRetailerInteraction() {
  const { isBot } = useRootData();
  const page = usePageData<CapiProductPage>();

  return ({ listing, selectedSize }: FireOptions) => {
    const retailers = getSortedStockListingsForSize(page, selectedSize).map(
      (option, index) => toRetailerOption(option, index, selectedSize)
    );

    return new RetailerInteractionEvent({
      isBot,
      product: fromProductDetailPage(page),
      retailerId: listing.affiliate.canonical_id,
      retailers,
      selectedSize
    }).send();
  };
}
